<template>
  <a-spin :spinning="confirmLoading">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form @submit="handleSubmit" :form="form">
        <a-form-item
          v-show="false"
          label="id"
        >
          <a-input
            v-decorator="['id']"
          />
        </a-form-item>
        <a-form-item
          v-show="false"
          label="status"
        >
          <a-input
            v-decorator="['status']"
          />
        </a-form-item>
        <a-form-item
          label="标题"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input
            :disabled="showable"
            v-decorator="[
              'headline',
              {rules: [{ required: true, message: '请输入文章名' }]}
            ]"
            placeholder="给你的文章起个名字" />
        </a-form-item>
        <a-form-item
          label="文字描述"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <j-editor
            v-if="flag"
            v-model="content" ></j-editor>
        </a-form-item>
        <a-form-item
          label="附件"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <upload
            :url="url"
            :fileListTemp="file"
            @updateFileList="(data) => changeList(data,'file')"
            v-decorator="['file']"
          />
        </a-form-item>
        <a-form-item
          label="指定人可见"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <a-radio-group @change="onChange" v-model="value" defaultValue="1">
            <a-radio :style="radioStyle" value="1">所有人</a-radio>
            <a-radio :style="radioStyle" value="0">
              指定人
              <a-select
                v-if="value === '0'"
                placeholder="请选择"
                :style="{ width: 100, marginLeft: 10 }"
                mode="multiple"
                :allowClear="true"
                :filterOption="filterOption"
                v-decorator="['userList']"
                :options="userList"
              >
              </a-select>
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          :wrapperCol="{ span: 24 }"
          style="text-align: center"
        >
          <a-button :loading="confirmLoading" :disabled="showable" htmlType="submit" type="primary" @click="handleOk">发布</a-button>
          <a-button key="cancel" @click="handleCancel" style="margin-left: 8px">返回</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-spin>
</template>

<script>

import { getObj, addObj, putObj } from '@/api/notice/notice'
import pick from 'lodash.pick'
import Upload from '../uploadDragger/Upload'
import { userDropDown } from '@/api/sys/user'
import JEditor from '@views/components/JEditor/JEditor'

export default {
  name: 'NoticeAddOrUpdate',
  components: {
    Upload,
    JEditor
  },
  data () {
    return {
      flag: false,
      content: '',
      confirmLoading: false,
      addable: false,
      visible: false,
      editable: false,
      showable: false,
      userList: null,
      file: [],
      url: 'api/storage/upload',
      type: 'add',
      value: 1,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      // form
      form: this.$form.createForm(this)

    }
  },
  // created  () {
  //   const noticeId = this.$route.query.id
  //   const type = this.$route.query.type
  //   this.value = this.$route.query.status
  //   this.edit(noticeId, type)
  // },
  activated () {
    this.flag = false
    this.content = ''
    const noticeId = this.$route.query.id
    const type = this.$route.query.type
    this.value = this.$route.query.status
    this.edit(noticeId, type)
  },
  methods: {
    changeList (data, str) {
      this.file = data
      this.form.setFieldsValue({ file: JSON.stringify(data) })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onChange (e) {
    },
    // 获取信息
    edit (id, type) {
      // this.flag = true
      this.visible = true
      userDropDown().then(res => {
        this.userList = res.data
      })
      if (type && type === 'add') {
        // 此处延时一下，不然v-if 反应不过来
        setTimeout(() => {
          this.file = []
          this.flag = true
        }, 100)
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = false
        getObj(id).then(res => {
          this.flag = true
          const record = res.data.data
          this.content = record.sxNotice.content
          this.file = JSON.parse(record.sxNotice.file)
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record.sxNotice, [
              'id',
              'headline',
              'status'
            ]))
          })
          const userIds = []
          record.userList.forEach(da => {
            userIds.push(da.value)
          })
          this.$nextTick(() => {
            setFieldsValue({ userList: userIds })
          })
        })
      } else {
        resetFields()
      }
    },

    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          const postData = {}
          postData.sxNotice = {
            id: values.id,
            headline: values.headline,
            content: this.content,
            status: values.status,
            file: values.file
          }
          postData.userIds = values.userList
          try {
            if (this.type === 'edit') {
              this.confirmLoading = false
              await putObj(postData).then((res) => {
                this.confirmLoading = false
                this.$message.success('修改成功', 1).then(() => {
                  this.$router.push({ name: 'noticeView' })
                })
              })
            } else {
              await addObj(postData).then((res) => {
                this.confirmLoading = false
                this.$message.success('保存成功', 1).then(() => {
                  this.$router.push({ name: 'noticeView' })
                })
              })
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.visible = false
            }, 1500)
          } catch (e) {
            this.$message.error(e.msg)
            this.confirmLoading = false
          }
        }
      })
    },
    handleCancel () {
      this.$router.push({ name: 'noticeView' })
    },
    // handler
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
        }
      })
    }
  }
}
</script>
